// API Configuration
// Production API endpoint - always uses https://manhattanhanovertalent.com
// Ignore environment variable if it contains localhost (old build artifact)
const envApiUrl = process.env.REACT_APP_API_URL;
const API_BASE_URL = (envApiUrl && !envApiUrl.includes('localhost') && !envApiUrl.includes('127.0.0.1'))
  ? envApiUrl
  : 'https://manhattanhanovertalent.com/php_backend/api';

// Build version identifier (helps identify if old build is cached)
const BUILD_VERSION = 'bf69f068-fixed-env-var';

// Log API configuration for debugging (only in browser)
if (typeof window !== 'undefined' && window.location) {
  console.log('API Configuration:', {
    hostname: window.location.hostname,
    protocol: window.location.protocol,
    API_BASE_URL: API_BASE_URL,
    BUILD_VERSION: BUILD_VERSION,
    envVar: process.env.REACT_APP_API_URL || 'not set',
    fullUrl: window.location.href
  });
  
  // Warn if API_BASE_URL contains localhost (indicates old build)
  if (API_BASE_URL.includes('localhost') || API_BASE_URL.includes('127.0.0.1')) {
    console.error('⚠️ WARNING: Old build detected! API_BASE_URL contains localhost:', API_BASE_URL);
    console.error('⚠️ Please clear browser cache and ensure new build is deployed.');
  }
}

export default API_BASE_URL;
